/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ListRenderedWidgetsRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v3/cash/widget_service.pb'
import {ListRenderedWidgetsResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v3/cash/widget_service.pb'


export const listRenderedWidgets = (request: ListRenderedWidgetsRequest, options?: CashRequestOptions) => post<ListRenderedWidgetsRequest, ListRenderedWidgetsResponse>("/cash-app/goose-cash/v3/list-rendered-widgets", request, {...options, rejectOnError: true })